import React from 'react'
import { useSelector } from 'react-redux'
import { getSettings } from 'src/store/data.store'
import { FooterBlock } from './FooterBlock'
import styles from './FooterBlocks.module.css'
import contentStyles from './FooterBlocksContent.module.css'

/** The three numbered blocks (footerBlock1-3 in site settings) */
export const FooterBlocks: React.FC = () => {
  const settings = useSelector(getSettings)
  if (!settings) {
    return null
  }
  const { footerBlock1, footerBlock2, footerBlock3 } = settings
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={contentStyles.container}>
          <FooterBlock title={footerBlock1.title} content={footerBlock1.content} type={'one'} />
          <FooterBlock title={footerBlock2.title} content={footerBlock2.content} type={'two'} />
          <FooterBlock title={footerBlock3.title} content={footerBlock3.content} type={'three'} />
        </div>
      </div>
    </div>
  )
}
